import React from 'react';
import NavBar from '../Shared/NavBar';
import HomeScreen from './HomeScreen';
import MainService from './MainService';
import HomeScreenFooter from './HomeScreenFooter';
import ClientBanner from './ClientBanner';
import Footer from '../Shared/Footer';
import { Helmet } from 'react-helmet-async';
function Home() {

    return (
    <div>
      <Helmet>
        <title>家居維修配對平台：搵師傅、水電維修、專業課程 | 維修王</title>
        {/* 描述包含多個服務項目，提高長尾流量 */}
        <meta name="description" content="維修王是香港首選家居維修配對平台，提供專業水電維修、冷氣清洗、油漆翻新及鋁窗維修服務。立即下載 App 預約認證師傅，或報讀家居維修課程，掌握入行創業技能。" />
        <meta property="og:title" content="維修王：一站式家居維修與師傅配對平台" />
        <meta property="og:description" content="搵師傅、學維修，全在維修王。專業師傅團隊即時報價，助你解決所有家居煩惱。" />
        <link rel="canonical" href="https://homerepairexperthk.com" />
      
      <script type="application/ld+json">
        {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "HomeAndConstructionBusiness", 
        "name": "維修王 Home Repair Expert HK",
        "image": "https://homerepairexperthk.com", 
        "@id": "https://homerepairexperthk.com",
        "url": "https://homerepairexperthk.com",
        "telephone": "+852-91031197", 
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "新蒲崗八達街9號",
          "addressLocality": "宏基中心二期-601室",
          "addressRegion": "香港",
          "addressCountry": "HK"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 22.336952530379314,
          "longitude":  114.1989616649237
        },
        "openingHoursSpecification": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday"
          ],
          "opens": "09:00",
          "closes": "18:00"
        },
        "sameAs": [
          "https://www.facebook.com/StarryDesignConsultantLimited/",
          "https://www.instagram.com/popular/%E7%B6%AD%E4%BF%AE%E7%8E%8B/"
        ],
        "areaServed": {
          "@type": "AdministrativeArea",
          "name": "Hong Kong"
        }
      })}
    </script>
      </Helmet>
      <HomeScreen />
      <ClientBanner/>
      <MainService />  
      <HomeScreenFooter/>
    
    </div>
  )
}

export default Home
